/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Col,
  Input,
  Spin,
  Typography,
  Button,
  TreeSelect,
} from 'antd';
import NumericInput from 'components/NumericInput';
import CurrencyInput from 'components/CurrencyInput';
import PercentageInput from 'components/PercentageInput';
import {
  getAcreedores,
  getCuentasContables,
} from 'api/catalogos/index';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import {
  SLUG_PATTERN,
  FLOAT_NUMER_PATTERN,
  integerRegExp,
} from 'utils/patterns';
import makeTree from 'utils/makeTreeFromCuentasContables';
import { checkToken } from 'api/utils';
import {
  DESCUENTO_RECURRENTE_Y_VARIABLE,
  DESCUENTO_DE_CALCULO_EXTERNO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import Select from 'components/Select';

import DescuentosEmpleadosDescuentos from 'views/Configuracion/Accesos/DescuentosEmpleadosDescuentos';
import DescuentosEmpleadosDeducciones from 'views/Configuracion/Accesos/DescuentosEmpleadosDeducciones';
import DescuentosEmpleadosPercepciones from 'views/Configuracion/Accesos/DescuentosEmpleadosPercepciones';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import { SaveOutlined } from '@ant-design/icons';

const { Text } = Typography;

// eslint-disable-next-line react/prop-types
const TipoDescuento = ({
  form,
  tipoDescuento,
  importeDescuento,
  setImporteDescuento,
  periodo,
  disableFields,
  esAsignacionMasiva = false,
  selectedRowKeys,
  descuentoEmpleadoAutorizadoInactivo,
  isBlocked,
  onFinish,
}) => {
  const [loading, setLoading] = useState(false);
  const [acreedores, setAcreedores] = useState([]);
  const [cuentasTree, setCuentasTree] = useState([]);
  const [periodos, setPeriodos] = useState([]);
  const [disableTipoDescuento, setDisableTipoDescuento] = useState(false);
  const [disablePorcentajeDescuento, setDisablePorcentajeDescuento] = useState(false);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [periodosFiltered, setPeriodosFiltered] = useState([]);
  const [periodosNominas, setPeriodosNominas] = useState([]);
  const [periodosNominasDetalles, setPeriodosNominasDetalles] = useState([]);
  // condicional para  deshbilitar campos segun estado
  // condicional para  deshbilitar campos
  const isFormDisabled = disableFields || descuentoEmpleadoAutorizadoInactivo || isBlocked;

  const agregarDisabledEnNivelMasProfundo = (arreglo) => {
    const agregarDisabledRecursivo = (nodo) => {
      if (!nodo.children || nodo.children.length === 0) {
        // eslint-disable-next-line no-param-reassign
        nodo.disabled = nodo?.tipo !== 7;
        return;
      }
      // eslint-disable-next-line no-param-reassign
      nodo.disabled = true;
      nodo.children.forEach((hijo) => agregarDisabledRecursivo(hijo));
    };
    arreglo.forEach((nodo) => agregarDisabledRecursivo(nodo));
  };

  const normalizeCuentasContables = (_data) => {
    if (_data) {
      const output = _data.map((item) => {
        const clone = { ...item };
        const children = normalizeCuentasContables(clone.children);
        const hasCuentasChildren = children.some((e) => e.conac);
        const selectable = clone.tipo !== 7 && !hasCuentasChildren;
        if (!children.length) {
          delete clone.children;
          return ({
            ...clone,
            title: `${clone.clave_visible || clone.clave} - ${clone.nombre}`,
            value: clone.id,
            key: clone.id,
            disabled: !selectable,
          });
        }
        return ({
          ...clone,
          title: `${clone.clave_visible || clone.clave} - ${clone.nombre}`,
          value: clone.id,
          key: clone.id,
          children,
          disabled: !selectable,
        });
      });
      return output;
    }
    return [];
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _acreedores,
        _cuentas,
        _periodosFiscales,
        _periodosNominasDetalles,
        _periodosNominas,
      ] = await Promise.all([
        getAcreedores(),
        getCuentasContables(),
        getPeriodosFiscales({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodosDeNominasDetalles(),
        getPeriodosDeNominas(),
      ]);
      if (mounted) {
        setAcreedores(_acreedores);
        setPeriodosFiscales(_periodosFiscales);
        const normalizedCuentas = normalizeCuentasContables(makeTree(_cuentas));
        agregarDisabledEnNivelMasProfundo(normalizedCuentas);
        setCuentasTree(normalizedCuentas);
        // eslint-disable-next-line max-len
        setPeriodosNominasDetalles(_periodosNominasDetalles);
        setPeriodosNominas(_periodosNominas);

        // Ejecutar el filtro inicial tan pronto como los datos y la prop 'periodo' estén listos
        const initial_periodo_fiscal = form.getFieldValue('periodo_fiscal');
        const _tipo_nomina_empleado = periodo; // Usar la prop

        let _periodosNominasFiltrados = _periodosNominas.filter(
          (e) => e.tipo_de_nomina_empleado === _tipo_nomina_empleado,
        );

        if (initial_periodo_fiscal) {
          _periodosNominasFiltrados = _periodosNominasFiltrados.filter(
            (e) => e.periodo_fiscal === initial_periodo_fiscal,
          );
        }

        const _periodosDetallesFiltrados = _periodosNominasDetalles.filter(
          (e) => _periodosNominasFiltrados.some(((x) => x.id === e.periodo_de_nomina)),
        );

        setPeriodosFiltered(_periodosDetallesFiltrados);

        if (tipoDescuento?.aplica_porcentaje_predeterminado_importe_variable) {
          form.setFieldValue('porcentaje_de_descuento', tipoDescuento?.porcentaje_predeterminado_importe_variable);
          setDisablePorcentajeDescuento(true);
        } else {
          setDisablePorcentajeDescuento(false);
        }
        if (tipoDescuento?.acreedor) {
          // Esperar hasta tener acreedores cargados
          const acreedorExiste = _acreedores.find((a) => a.id === tipoDescuento.acreedor);
          if (acreedorExiste) {
            form.setFieldValue('acreedor', tipoDescuento.acreedor);
          }
        }
        if (tipoDescuento) {
          if (tipoDescuento.id === 2) {
            setDisableTipoDescuento(true);
          } else {
            setDisableTipoDescuento(false);
          }
        }
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, [tipoDescuento, periodo]); 
  useEffect(() => {
  // Ejecutar solo cuando los periodos ya se cargaron
    if (!periodosNominasDetalles?.length || !form) return;

    const currentPeriodo = form.getFieldValue('periodo_de_nomina_detalle');

    // Si el valor actual es un ID numérico, busca su objeto correspondiente
    if (currentPeriodo && typeof currentPeriodo === 'number') {
      const periodoDetalleObj = periodosNominasDetalles.find(
        (p) => p.id === currentPeriodo,
      );

      if (periodoDetalleObj) {
        form.setFieldValue('periodo_de_nomina_detalle', periodoDetalleObj.id);
      }
    }
  }, [periodosNominasDetalles, form]);

  const filterPeriodos = (_data) => {
    const {
      periodo_fiscal,
    } = form.getFieldsValue();

    // Usar el periodo fiscal seleccionado en el formulario
    const _periodo_fiscal_seleccionado = periodo_fiscal || _data?.periodo_fiscal;
    const _tipo_nomina_empleado = periodo;

    // 1. Filtrar los periodos de nómina principales por el TIPO DE NÓMINA DEL EMPLEADO
    let _periodosNominasFiltrados = periodosNominas.filter(
      (e) => e.tipo_de_nomina_empleado === _tipo_nomina_empleado,
    );

    // 2. Si el usuario seleccionó un periodo fiscal, filtrar también por eso
    if (_periodo_fiscal_seleccionado) {
      _periodosNominasFiltrados = _periodosNominasFiltrados.filter(
        (e) => e.periodo_fiscal === _periodo_fiscal_seleccionado,
      );
    }

    // 3. Filtrar los detalles de nómina basados en los periodos principales ya filtrados
    const _periodosDetallesFiltered = periodosNominasDetalles.filter(
      (e) => _periodosNominasFiltrados.some(((x) => x.id === e.periodo_de_nomina)),
    );

    setPeriodosFiltered(_periodosDetallesFiltered);
  };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
    valor: [
      requiredRule,
      {
        validator: async (rule, value) => {
          if (value) {
            const numeroFlotante = FLOAT_NUMER_PATTERN.test(value);
            if (!numeroFlotante || value > 100 || value < 0) {
              throw new Error('Ingrese un valor válido');
            }
          }
        },
      },
    ],
    cantidad: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
    ],
    entero: [
      requiredRule,
      {
        pattern: integerRegExp,
        message: 'Ingrese un valor válido',
      },
    ],
  };

  //   // Formulario para el tipo de descuento 1
  //   const Form1 = (
  //     <Form
  //       layout="vertical"
  //       form={form}
  //       scrollToFirstError
  //       name="general"
  //     >
  //       <Row gutter={10}>
  //         {tipoDescuento?.acreedor ? (
  //           <Col xs={24} sm={24} md={8}>
  //             <Form.Item
  //               name="acreedor"
  //               label="Acreedor"
  //               rules={[{ required: true, message: 'Seleccione un acreedor' }]}
  //               hasFeedback
  //             >
  //               <Select
  //                 dataSource={acreedores.map((a) => ({
  //                   id: a.id,
  //                   label: `${a.clave} - ${a.razon_social || 'SIN RAZÓN SOCIAL'}`,
  //                 }))}
  //                 keyProp="id"
  //                 labelProp="label"
  //                 disabled
  //               />
  //             </Form.Item>
  //           </Col>
  //         ) : null}
  //         {!tipoDescuento?.aplica_rangos_salariales
  //         && tipoDescuento?.tipo_de_descuento === DESCUENTO_RECURRENTE_Y_VARIABLE
  //           ? (
  //             <Col xs={24} sm={24} md={8}>
  //               <PercentageInput
  //                 name="porcentaje_de_descuento"
  //                 label="Porcentaje de Descuento"
  //                 rules={rules.valor}
  //                 disabled={disablePorcentajeDescuento
  //                   || descuentoEmpleadoAutorizadoInactivo
  //                   || isBlocked}
  //               />
  //             </Col>
  //           ) : null}
  //         {/* <Col xs={24} sm={24} md={8}>
  //           <Form.Item
  //             name="periodo_fiscal"
  //             label="Periodo Fiscal"
  //             rules={rules.estatus}
  //             hasFeedback
  //           >
  //             <Select
  //               dataSource={periodosFiscales}
  //               disabled={selectedRowKeys.length}
  //               onChange={() => {
  //                 form.resetFields(['periodo_de_nomina_detalle', 'dias_calculados']);
  //                 filterPeriodos();
  //               }}
  //             />
  //           </Form.Item>
  //         </Col> */}
  //         <Col xs={24} sm={24} md={8}>
  //           <Form.Item
  //             name="periodo_de_nomina_detalle"
  //             label="Periodo"
  //             rules={rules.required}
  //             hasFeedback
  //           >
  //             <Select
  //               keyProp="id"
  //               labelProp="numero_de_nomina"
  //               disabled={selectedRowKeys.length}
  //               // dataSource={periodosNominasDetalles.filter((e) => periodosFiltered.some((x) => x.id === e.id))} // <-- ESTO ES INCORRECTO
  //               dataSource={periodosFiltered}
  //               render={(value) => `${value?.numero_de_nomina} (${value?.fecha_inicial} al ${value?.fecha_final})`}
  //             />
  //           </Form.Item>
  //         </Col>
  //         {tipoDescuento?.requiere_identificar_percepciones && !esAsignacionMasiva && selectedRowKeys.length
  //           ? (
  //             <Row>
  //               <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Percepciones</p>
  //               <div style={{ maxHeight: '300px', overflow: 'auto' }}>
  //                 <DescuentosEmpleadosPercepciones
  //                   descuentoEmpleado={selectedRowKeys[0]}
  //                   descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
  //                   isBlocked={isBlocked}
  //                 />
  //               </div>
  //             </Row>
  //           ) : null}
  //         {tipoDescuento?.requiere_identificar_deducciones && !esAsignacionMasiva && selectedRowKeys.length
  //           ? (
  //             <Row>
  //               <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Deducciones</p>
  //               <div style={{ maxHeight: '300px', overflow: 'auto' }}>
  //                 <DescuentosEmpleadosDeducciones
  //                   descuentoEmpleado={selectedRowKeys[0]}
  //                   descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
  //                   isBlocked={isBlocked}
  //                 />
  //               </div>
  //             </Row>
  //           ) : null}
  //         {tipoDescuento?.requiere_identificar_descuentos && !esAsignacionMasiva && selectedRowKeys.length
  //           ? (
  //             <Row>
  //               <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Descuentos Del Empleado</p>
  //               <div style={{ maxHeight: '300px', overflow: 'auto' }}>
  //                 <DescuentosEmpleadosDescuentos
  //                   descuentoEmpleado={selectedRowKeys[0]}
  //                   descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
  //                   isBlocked={isBlocked}
  //                 />
  //               </div>
  //             </Row>
  //           ) : null }
  //       </Row>
  //     </Form>
  //   );

  //   // Formulario para el tipo de descuento 2
  //   const Form2 = (
  //     <Form
  //       layout="vertical"
  //       form={form}
  //       scrollToFirstError
  //       name="general"
  //     >
  //       <Row gutter={10}>
  //         <Col xs={24} sm={24} md={8}>
  //           <CurrencyInput
  //             name="importe_base"
  //             label="Importe Base"
  //             rules={rules.cantidad}
  //             disabled={disableTipoDescuento || isBlocked}
  //             onChange={(value) => {
  //               if (form.getFieldValue('no_de_periodos_de_descuento') > 0) {
  //                 setImporteDescuento((value / form.getFieldValue('no_de_periodos_de_descuento')).toFixed(2));
  //               } else {
  //                 setImporteDescuento(value);
  //               }
  //             }}
  //           />
  //         </Col>
  //         <Col xs={24} sm={24} md={8}>
  //           <NumericInput
  //             name="no_de_periodos_de_descuento"
  //             label="No. de Periodos de Descuento"
  //             rules={rules.entero}
  //             disabled={disableTipoDescuento || isBlocked}
  //             onChange={(e) => {
  //               const { value } = e.target;
  //               if (value > 0) {
  //                 setImporteDescuento((form.getFieldValue('importe_base') / value).toFixed(2));
  //               } else {
  //                 setImporteDescuento(form.getFieldValue('importe_base'));
  //               }
  //             }}
  //           />
  //         </Col>
  //         <Col xs={24} sm={24} md={8}>
  //           <CurrencyInput
  //             label="Importe de Descuento"
  //             value={importeDescuento}
  //             disabled
  //           />
  //         </Col>
  //         <Col xs={24} sm={24} md={8}>
  //           <NumericInput
  //             name="no_de_periodo_inicial"
  //             label="No. de Descuento con que Inicia"
  //             rules={rules.entero}
  //             disabled={disableTipoDescuento || isBlocked}
  //           />
  //         </Col>
  //         <Col xs={24} sm={24} md={8}>
  //           <Form.Item
  //             name="periodo_de_nomina_detalle"
  //             label="Periodo"
  //             rules={rules.required}
  //             hasFeedback
  //           >
  //             <Select
  //               keyProp="id"
  //               labelProp="numero_de_nomina"
  //               disabled={selectedRowKeys.length}
  //               // dataSource={periodosNominasDetalles.filter((e) => periodosFiltered.some((x) => x.id === e.id))} // <-- ESTO ES INCORRECTO
  //               dataSource={periodosFiltered}
  //               render={(value) => `${value?.numero_de_nomina} (${value?.fecha_inicial} al ${value?.fecha_final})`}
  //             />
  //           </Form.Item>
  //         </Col>

  //         {tipoDescuento?.requiere_identificar_percepciones && !esAsignacionMasiva && selectedRowKeys.length
  //           ? (
  //             <Row>
  //               <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Percepciones</p>
  //               <div style={{ maxHeight: '300px', overflow: 'auto' }}>
  //                 <DescuentosEmpleadosPercepciones
  //                   descuentoEmpleado={selectedRowKeys[0]}
  //                   descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
  //                   isBlocked={isBlocked}
  //                 />
  //               </div>
  //             </Row>
  //           ) : null}
  //         {tipoDescuento?.requiere_identificar_deducciones && !esAsignacionMasiva && selectedRowKeys.length
  //           ? (
  //             <Row>
  //               <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Deducciones</p>
  //               <div style={{ maxHeight: '300px', overflow: 'auto' }}>
  //                 <DescuentosEmpleadosDeducciones
  //                   descuentoEmpleado={selectedRowKeys[0]}
  //                   descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
  //                   isBlocked={isBlocked}
  //                 />
  //               </div>
  //             </Row>
  //           ) : null}
  //         {tipoDescuento?.requiere_identificar_descuentos && !esAsignacionMasiva && selectedRowKeys.length
  //           ? (
  //             <Row>
  //               <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Descuentos Del Empleado</p>
  //               <div style={{ maxHeight: '300px', overflow: 'auto' }}>
  //                 <DescuentosEmpleadosDescuentos
  //                   descuentoEmpleado={selectedRowKeys[0]}
  //                   descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
  //                   isBlocked={isBlocked}
  //                 />
  //               </div>
  //             </Row>
  //           ) : null }
  //         { !esAsignacionMasiva ? (
  //           <Col xs={24} sm={24} md={8}>
  //             <Form.Item
  //               name="cuenta_contable"
  //               label="Cuenta Contable"
  //               rules={rules.required}
  //               hasFeedback
  //             >
  //               <Select
  //                 labelProp="nombre"
  //                 dataSource={cuentas}
  //                 disabled={disableFields || isBlocked}
  //                 keyLabelRender
  //               />
  //             </Form.Item>
  //           </Col>
  //         ) : null}
  //       </Row>
  //     </Form>
  //   );

  //   // Formulario para el tipo de descuento 3
  //   const Form3 = (
  //     <Form
  //       layout="vertical"
  //       form={form}
  //       scrollToFirstError
  //       name="general"
  //     >
  //       <Row gutter={10}>
  //         {tipoDescuento?.acreedor ? (
  //           <Col xs={24} sm={24} md={8}>
  //             <Form.Item
  //               label="Acreedor"
  //               hasFeedback
  //             >
  //               <Input
  //                 allowClear
  //                 disabled
  //                 value={acreedores.find((e) => e.id === tipoDescuento?.acreedor)?.nombre_comercial}
  //               />
  //             </Form.Item>
  //           </Col>
  //         ) : null}
  //         <Col xs={24} sm={24} md={8}>
  //           <CurrencyInput
  //             name="importe_fijo"
  //             label="Importe de Descuento"
  //             rules={rules.cantidad}
  //             disabled={disableFields || isBlocked}
  //           />
  //         </Col>
  //         <Col xs={24} sm={24} md={8}>
  //           <Form.Item
  //             name="periodo_de_nomina_detalle"
  //             label="Periodo Único de Descuento"
  //             rules={rules.required}
  //             hasFeedback
  //           >
  //             <Select
  //               keyProp="id"
  //               labelProp="numero_de_nomina"
  //               disabled={selectedRowKeys.length}
  //               // dataSource={periodosNominasDetalles.filter((e) => periodosFiltered.some((x) => x.id === e.id))} // <-- ESTO ES INCORRECTO
  //               dataSource={periodosFiltered}
  //               render={(value) => `${value?.numero_de_nomina} (${value?.fecha_inicial} al ${value?.fecha_final})`}
  //             />
  //           </Form.Item>
  //         </Col>

  //         {tipoDescuento?.requiere_identificar_percepciones && !esAsignacionMasiva && selectedRowKeys.length
  //           ? (
  //             <Row>
  //               <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Percepciones</p>
  //               <div style={{ maxHeight: '300px', overflow: 'auto' }}>
  //                 <DescuentosEmpleadosPercepciones
  //                   descuentoEmpleado={selectedRowKeys[0]}
  //                   descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
  //                   isBlocked={isBlocked}
  //                 />
  //               </div>
  //             </Row>
  //           ) : null}
  //         {tipoDescuento?.requiere_identificar_deducciones && !esAsignacionMasiva && selectedRowKeys.length
  //           ? (
  //             <Row>
  //               <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Deducciones</p>
  //               <div style={{ maxHeight: '300px', overflow: 'auto' }}>
  //                 <DescuentosEmpleadosDeducciones
  //                   descuentoEmpleado={selectedRowKeys[0]}
  //                   descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
  //                   isBlocked={isBlocked}
  //                 />
  //               </div>
  //             </Row>
  //           ) : null}
  //         {tipoDescuento?.requiere_identificar_descuentos && !esAsignacionMasiva && selectedRowKeys.length
  //           ? (
  //             <Row>
  //               <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Descuentos Del Empleado</p>
  //               <div style={{ maxHeight: '300px', overflow: 'auto' }}>
  //                 <DescuentosEmpleadosDescuentos
  //                   descuentoEmpleado={selectedRowKeys[0]}
  //                   descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
  //                   isBlocked={isBlocked}
  //                 />
  //               </div>
  //             </Row>
  //           ) : null }

  //       </Row>
  //     </Form>
  //   );

  //   // Formulario para el tipo de descuento 3
  //   const Form4 = (
  //     <Form
  //       layout="vertical"
  //       form={form}
  //       scrollToFirstError
  //       name="general"
  //     >
  //       <Row gutter={10}>
  //         <Col xs={24} sm={24} md={8}>
  //           <CurrencyInput
  //             name="importe_fijo"
  //             label="Importe de Descuento"
  //             rules={rules.cantidad}
  //             disabled={disableFields || isBlocked}
  //           />
  //         </Col>
  //         <Col xs={24} sm={24} md={8}>
  //           <Form.Item
  //             name="periodo_de_nomina_detalle"
  //             label="Periodo de Inicio de Descuento"
  //             rules={rules.required}
  //             hasFeedback
  //           >
  //             <Select
  //               keyProp="id"
  //               labelProp="numero_de_nomina"
  //               disabled={selectedRowKeys.length}
  //               // dataSource={periodosNominasDetalles.filter((e) => periodosFiltered.some((x) => x.id === e.id))} // <-- ESTO ES INCORRECTO
  //               dataSource={periodosFiltered}
  //               render={(value) => `${value?.numero_de_nomina} (${value?.fecha_inicial} al ${value?.fecha_final})`}
  //             />
  //           </Form.Item>
  //         </Col>
  //         {tipoDescuento?.requiere_identificar_percepciones && !esAsignacionMasiva && selectedRowKeys.length
  //           ? (
  //             <Row>
  //               <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Percepciones</p>
  //               <div style={{ maxHeight: '300px', overflow: 'auto' }}>
  //                 <DescuentosEmpleadosPercepciones
  //                   descuentoEmpleado={selectedRowKeys[0]}
  //                   descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
  //                   isBlocked={isBlocked}
  //                 />
  //               </div>
  //             </Row>
  //           ) : null}
  //         {tipoDescuento?.requiere_identificar_deducciones && !esAsignacionMasiva && selectedRowKeys.length
  //           ? (
  //             <Row>
  //               <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Deducciones</p>
  //               <div style={{ maxHeight: '300px', overflow: 'auto' }}>
  //                 <DescuentosEmpleadosDeducciones
  //                   descuentoEmpleado={selectedRowKeys[0]}
  //                   descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
  //                   isBlocked={isBlocked}
  //                 />
  //               </div>
  //             </Row>
  //           ) : null}
  //         {tipoDescuento?.requiere_identificar_descuentos && !esAsignacionMasiva && selectedRowKeys.length
  //           ? (
  //             <Row>
  //               <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Descuentos Del Empleado</p>
  //               <div style={{ maxHeight: '300px', overflow: 'auto' }}>
  //                 <DescuentosEmpleadosDescuentos
  //                   descuentoEmpleado={selectedRowKeys[0]}
  //                   descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
  //                   isBlocked={isBlocked}
  //                 />
  //               </div>
  //             </Row>
  //           ) : null }
  //       </Row>
  //     </Form>
  //   );

  //   // Formulario para el tipo de descuento 3
  //   const Form5 = (
  //     <Form
  //       layout="vertical"
  //       form={form}
  //       scrollToFirstError
  //       name="general"
  //     >
  //       <Row gutter={10}>
  //         {tipoDescuento?.acreedor ? (
  //           <Col xs={24} sm={24} md={8}>
  //             <Form.Item
  //               label="Acreedor"
  //               hasFeedback
  //             >
  //               <Input
  //                 allowClear
  //                 disabled
  //                 value={acreedores.find((e) => e.id === tipoDescuento?.acreedor)?.nombre_comercial}
  //               />
  //             </Form.Item>
  //           </Col>
  //         ) : null}
  //         <Col xs={24} sm={24} md={8}>
  //           <CurrencyInput
  //             name="importe_fijo"
  //             label="Importe de Descuento"
  //             rules={rules.cantidad}
  //             disabled={disableFields || isBlocked}
  //           />
  //         </Col>
  //         <Col xs={24} sm={24} md={8}>
  //           <Form.Item
  //             name="periodo_de_nomina_detalle"
  //             label="Periodo de Inicio de Descuento"
  //             rules={rules.required}
  //             hasFeedback
  //           >
  //             <Select
  //               keyProp="id"
  //               labelProp="numero_de_nomina"
  //               disabled={selectedRowKeys.length}
  //               // dataSource={periodosNominasDetalles.filter((e) => periodosFiltered.some((x) => x.id === e.id))} // <-- ESTO ES INCORRECTO
  //               dataSource={periodosFiltered}
  //               render={(value) => `${value?.numero_de_nomina} (${value?.fecha_inicial} al ${value?.fecha_final})`}
  //             />
  //           </Form.Item>
  //         </Col>
  //         {tipoDescuento?.requiere_identificar_percepciones && !esAsignacionMasiva && selectedRowKeys.length
  //           ? (
  //             <Row>
  //               <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Percepciones</p>
  //               <div style={{ maxHeight: '300px', overflow: 'auto' }}>
  //                 <DescuentosEmpleadosPercepciones
  //                   descuentoEmpleado={selectedRowKeys[0]}
  //                   descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
  //                   isBlocked={isBlocked}
  //                 />
  //               </div>
  //             </Row>
  //           ) : null}
  //         {tipoDescuento?.requiere_identificar_deducciones && !esAsignacionMasiva && selectedRowKeys.length
  //           ? (
  //             <Row>
  //               <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Deducciones</p>
  //               <div style={{ maxHeight: '300px', overflow: 'auto' }}>
  //                 <DescuentosEmpleadosDeducciones
  //                   descuentoEmpleado={selectedRowKeys[0]}
  //                   descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
  //                   isBlocked={isBlocked}
  //                 />
  //               </div>
  //             </Row>
  //           ) : null}
  //         {tipoDescuento?.requiere_identificar_descuentos && !esAsignacionMasiva && selectedRowKeys.length
  //           ? (
  //             <Row>
  //               <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Descuentos Del Empleado</p>
  //               <div style={{ maxHeight: '300px', overflow: 'auto' }}>
  //                 <DescuentosEmpleadosDescuentos
  //                   descuentoEmpleado={selectedRowKeys[0]}
  //                   descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
  //                   isBlocked={isBlocked}
  //                 />
  //               </div>
  //             </Row>
  //           ) : null }
  //       </Row>
  //     </Form>
  //   );

  //   const setForm = () => {
  //     let formulario;
  //     switch (tipoDescuento?.tipo_de_descuento) {
  //       case 1:
  //         formulario = Form1;
  //         break;
  //       case 2:
  //         formulario = Form2;
  //         break;
  //       case 3:
  //         formulario = Form3;
  //         break;
  //       case 4:
  //         formulario = Form4;
  //         break;
  //       case 5:
  //         formulario = Form5;
  //         break;
  //       default:
  //         formulario = (
  //           <Row>
  //             <Text
  //               style={{
  //                 paddingTop: '10%',
  //                 width: '100%',
  //                 textAlign: 'center',
  //               }}
  //             >
  //               Seleccione un Concepto de Descuento
  //             </Text>
  //           </Row>
  //         );
  //         break;
  //     }

  //     return formulario;
  //   };

  //   return (
  //     <Row className="container">
  //       <Spin tip="Cargando..." spinning={loading}>
  //         {setForm()}
  //       </Spin>
  //     </Row>
  //   );
  // };
  // export default TipoDescuento;

  const renderDynamicForm = () => {
    if (!tipoDescuento) {
      return (
        <Row>
          <Text style={{ paddingTop: '10%', width: '100%', textAlign: 'center' }}>
            Seleccione un Concepto de Descuento
          </Text>
        </Row>
      );
    }

    // Determinar etiqueta del periodo
    let labelPeriodo = 'Periodo';
    if (tipoDescuento?.aplica_periodo_de_inicio_de_descuento) labelPeriodo = 'Periodo de Inicio de Descuento';
    if (tipoDescuento?.aplica_periodo_unico_de_descuento) labelPeriodo = 'Periodo Único de Descuento';

    const isImporteCalculated = tipoDescuento?.aplica_importe_base && tipoDescuento?.aplica_no_periodos_determinados;

    return (
      <Form layout="vertical" form={form} scrollToFirstError name="general">
        <Row gutter={10}>

          {/* 1. ACREEDOR (Si el tipo de descuento tiene un acreedor predefinido o lo requiere) */}
          {tipoDescuento?.acreedor ? (
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="acreedor"
                label="Acreedor"
                rules={[{ required: true, message: 'Seleccione un acreedor' }]}
                hasFeedback
              >
                <Select
                  dataSource={acreedores.map((a) => ({
                    id: a.id,
                    label: `${a.clave} - ${a.razon_social || 'SIN RAZÓN SOCIAL'}`,
                  }))}
                  keyProp="id"
                  labelProp="label"
                  disabled={isFormDisabled}
                />
              </Form.Item>
            </Col>
          ) : null}

          {/* 2. IMPORTE BASE */}
          {tipoDescuento?.aplica_importe_base ? (
            <Col xs={24} sm={24} md={8}>
              <CurrencyInput
                name="importe_base"
                label="Importe Base"
                rules={rules.cantidad}
                disabled={isFormDisabled}
                onChange={(value) => {
                  const numPeriodos = form.getFieldValue('no_de_periodos_de_descuento');
                  if (numPeriodos > 0) {
                    setImporteDescuento((value / numPeriodos).toFixed(2));
                    // Si el importe fijo se guarda en DB, actualizamos el campo form
                    form.setFieldValue('importe_fijo', (value / numPeriodos).toFixed(2));
                  } else {
                    setImporteDescuento(value);
                  }
                }}
              />
            </Col>
          ) : null}

          {/* 3. NO. DE PERIODOS DE DESCUENTO */}
          {tipoDescuento?.aplica_no_periodos_determinados ? (
            <Col xs={24} sm={24} md={8}>
              <NumericInput
                name="no_de_periodos_de_descuento"
                label="No. de Periodos de Descuento"
                rules={rules.entero}
                disabled={isFormDisabled}
                onChange={(e) => {
                  const { value } = e.target;
                  const base = form.getFieldValue('importe_base') || 0;
                  if (value > 0) {
                    const calculado = (base / value).toFixed(2);
                    setImporteDescuento(calculado);
                    form.setFieldValue('importe_fijo', calculado);
                  } else {
                    setImporteDescuento(base);
                  }
                }}
              />
            </Col>
          ) : null}

          {/* 4. IMPORTE DE DESCUENTO (FIJO O CALCULADO) */}
          {tipoDescuento?.aplica_importe_fijo || tipoDescuento?.aplica_determinacion_de_importe_fijo_de_descuento || tipoDescuento?.tipo_de_descuento === DESCUENTO_DE_CALCULO_EXTERNO ? (
            <Col xs={24} sm={24} md={8}>
              {isImporteCalculated ? (
                // Si es calculado, mostramos un Input deshabilitado o CurrencyInput deshabilitado
                <CurrencyInput
                  label="Importe de Descuento"
                  value={importeDescuento}
                  disabled={isFormDisabled}
                />
              ) : (
                // Si es editable
                <CurrencyInput
                  name="importe_fijo"
                  label="Importe de Descuento"
                  rules={rules.cantidad}
                  disabled={isFormDisabled}
                />
              )}
            </Col>
          ) : null}

          {/* 5. PORCENTAJE (Para casos variables) */}
          {!tipoDescuento?.aplica_rangos_salariales
             && tipoDescuento?.tipo_de_descuento === DESCUENTO_RECURRENTE_Y_VARIABLE
             && !tipoDescuento?.aplica_importe_fijo ? (
               <Col xs={24} sm={24} md={8}>
                 <PercentageInput
                   name="porcentaje_de_descuento"
                   label="Porcentaje de Descuento"
                   rules={rules.valor}
                   disabled={disablePorcentajeDescuento || descuentoEmpleadoAutorizadoInactivo || isBlocked}
                 />
               </Col>
            ) : null}

          {/* 5.1 ORDEN DE CALCULO: desempate explicito frente a otros Descuentos Empleados
               del mismo empleado que compartan la misma Prioridad del Descuento del catalogo
               (p.ej. dos pensiones alimenticias del mismo tipo) */}
          <Col xs={24} sm={24} md={8}>
            <NumericInput
              name="orden_de_calculo"
              label="Orden de Cálculo"
              rules={[
                {
                  pattern: integerRegExp,
                  message: 'Ingrese un valor válido',
                },
              ]}
              disabled={isFormDisabled}
            />
          </Col>

          {/* 6. NO. DE DESCUENTO INICIAL */}
          {tipoDescuento?.aplica_no_de_descuento_con_que_inicia ? (
            <Col xs={24} sm={24} md={8}>
              <NumericInput
                name="no_de_periodo_inicial"
                label="No. de Descuento con que Inicia"
                rules={rules.entero}
                disabled={isFormDisabled}
              />
            </Col>
          ) : null}

          {/* 7. PERIODO DE NOMINA (Inicio o Único) */}
          {/* {tipoDescuento?.aplica_periodo_de_inicio_de_descuento || tipoDescuento?.aplica_periodo_unico_de_descuento ? ( */}
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="periodo_de_nomina_detalle"
              label="Periodo de Nomina"
              // label={labelPeriodo}
              rules={rules.required}
              hasFeedback
            >
              <Select
                keyProp="id"
                labelProp="numero_de_nomina"
                disabled={isFormDisabled}
                dataSource={periodosFiltered}
                render={(value) => `${value?.numero_de_nomina} (${value?.fecha_inicial} al ${value?.fecha_final})`}
              />
            </Form.Item>
          </Col>
          {/* ) : null} */}

          {/* 8. CUENTA CONTABLE */}
          {(!esAsignacionMasiva && tipoDescuento?.aplica_cuenta_contable_del_empleado) ? (
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="cuenta_contable"
                label="Cuenta Contable del Empleado"
                rules={rules.required}
                hasFeedback
              >
                <TreeSelect
                  showSearch
                  allowClear
                  placeholder="Busca por clave o nombre"
                  treeNodeFilterProp="title"
                  style={{ width: '100%' }}
                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                  treeData={cuentasTree}
                  disabled={isFormDisabled}
                />
              </Form.Item>
            </Col>
          ) : null}

          {/* TABLAS ADICIONALES */}
          {tipoDescuento?.requiere_identificar_percepciones && !esAsignacionMasiva && selectedRowKeys.length ? (
            <Row style={{ width: '100%' }}>
              <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Percepciones</p>
              <div style={{ maxHeight: '300px', overflow: 'auto', width: '100%' }}>
                <DescuentosEmpleadosPercepciones
                  descuentoEmpleado={selectedRowKeys[0]}
                  descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
                  disabled={isFormDisabled}
                />
              </div>
            </Row>
          ) : null}

          {tipoDescuento?.requiere_identificar_deducciones && !esAsignacionMasiva && selectedRowKeys.length ? (
            <Row style={{ width: '100%' }}>
              <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Deducciones</p>
              <div style={{ maxHeight: '300px', overflow: 'auto', width: '100%' }}>
                <DescuentosEmpleadosDeducciones
                  descuentoEmpleado={selectedRowKeys[0]}
                  descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
                  disabled={isFormDisabled}
                />
              </div>
            </Row>
          ) : null}

          {tipoDescuento?.requiere_identificar_descuentos && !esAsignacionMasiva && selectedRowKeys.length ? (
            <Row style={{ width: '100%' }}>
              <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Descuentos Del Empleado</p>
              <div style={{ maxHeight: '300px', overflow: 'auto', width: '100%' }}>
                <DescuentosEmpleadosDescuentos
                  descuentoEmpleado={selectedRowKeys[0]}
                  descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizadoInactivo}
                  disabled={isFormDisabled}
                />
              </div>
            </Row>
          ) : null}

        </Row>
      </Form>
    );
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {renderDynamicForm()}
      </Spin>
    </Row>
  );
};

export default TipoDescuento;
